import React from 'react';

function AtaModal({
  show,
  onClose,
  onSubmit,
  ataForm,
  handleChange,
  title = 'CADASTRO DA ATA',
}) {
  if (!show) return null;

  // Verifica se está editando ou criando novo
  const isEdit = Boolean(ataForm && ataForm.data && ataForm.hora);

  const handleSubmit = e => {
    e.preventDefault();
    onSubmit(e);
  };

  return (
    <div
      className="modal show d-block"
      tabIndex="-1"
      style={{ backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1055, position: 'fixed' }}
    >
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header bg-success text-white" style={{ padding: '0.35rem 1rem' }}>
            <h6 className="modal-title mb-0 small">
              <i className="bi bi-calendar-plus me-2"></i>
              {title}
            </h6>
            <button
              type="button"
              className="btn-close btn-close-white"
              onClick={onClose}
            ></button>
          </div>
          <div className="modal-body">
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-md-6 mb-3">
                  <label className="form-label">Data da Ata *</label>
                  <input
                    type="date"
                    className="form-control"
                    name="data"
                    value={ataForm.data}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="col-md-6 mb-3">
                  <label className="form-label">Hora da Ata *</label>
                  <input
                    type="time"
                    className="form-control"
                    name="hora"
                    value={ataForm.hora}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-md-4 mb-3">
                  <label className="form-label">Data Início</label>
                  <input
                    type="date"
                    className="form-control"
                    name="dataIni"
                    value={ataForm.dataIni}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-md-4 mb-3">
                  <label className="form-label">Data Fim</label>
                  <input
                    type="date"
                    className="form-control"
                    name="dataFim"
                    value={ataForm.dataFim}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-md-4 mb-3">
                  <label className="form-label">Data Edital</label>
                  <input
                    type="date"
                    className="form-control"
                    name="dataEdital"
                    value={ataForm.dataEdital}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-md-8 mb-3">
                  <label className="form-label">Nome Presidente</label>
                  <input
                    type="text"
                    className="form-control"
                    name="presidenteNome"
                    value={ataForm.presidenteNome}
                    onChange={handleChange}
                    maxLength="70"
                    placeholder="Nome completo do presidente"
                  />
                </div>
                <div className="col-md-4 mb-3">
                  <label className="form-label">Pronome</label>
                  <select
                    className="form-select"
                    name="presidentePronome"
                    value={ataForm.presidentePronome}
                    onChange={handleChange}
                  >
                    <option value="">Selecione...</option>
                    <option value="SR.">SR.</option>
                    <option value="SRA.">SRA.</option>
                    <option value="SRTA.">SRTA.</option>
                  </select>
                </div>
              </div>

              <div className="row">
                <div className="col-md-8 mb-3">
                  <label className="form-label">Nome Secretário</label>
                  <input
                    type="text"
                    className="form-control"
                    name="secretarioNome"
                    value={ataForm.secretarioNome}
                    onChange={handleChange}
                    maxLength="70"
                    placeholder="Nome completo do secretário"
                  />
                </div>
                <div className="col-md-4 mb-3">
                  <label className="form-label">Pronome</label>
                  <select
                    className="form-select"
                    name="secretarioPronome"
                    value={ataForm.secretarioPronome}
                    onChange={handleChange}
                  >
                    <option value="">Selecione...</option>
                    <option value="SR.">SR.</option>
                    <option value="SRA.">SRA.</option>
                    <option value="SRTA.">SRTA.</option>
                  </select>
                </div>
              </div>

              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={onClose}
                >
                  <i className="bi bi-x-circle me-1"></i>
                  Cancelar
                </button>
                <button
                  type="submit"
                  className={isEdit ? 'btn btn-warning' : 'btn btn-success'}
                >
                  <i
                    className={
                      isEdit
                        ? 'bi bi-pencil-square me-1'
                        : 'bi bi-check-lg me-1'
                    }
                  ></i>
                  {isEdit ? 'Atualizar Ata' : 'Salvar Ata'}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AtaModal;
